import { isEmpty } from 'lodash'

import formatEvidenceReference from './formatEvidenceReference'

// Monta um texto simples (colunas separadas por tab) da aderência aos requisitos,
// pronto para o colaborador colar em Word/Excel/e-mail.
const buildApplicabilityText = ({
  applicability,
  evidenceMap = {},
  statusLabel = {},
} = {}) => {
  if (!applicability || isEmpty(applicability.items)) return ''

  const lines = ['Aderência aos requisitos']

  if (applicability.coverage_summary) {
    lines.push('', applicability.coverage_summary)
  }

  lines.push('', ['Req.', 'Status', 'Evidência', 'Como atende'].join('\t'))

  applicability.items.forEach((item) => {
    const references = (item.satisfied_by || [])
      .map((evidence) => formatEvidenceReference(evidence, evidenceMap))
      .filter(Boolean)
      .join(' ')

    const requirement = item.requirement || ''

    lines.push(
      [
        requirement,
        statusLabel[item.status] || item.status,
        references || '—',
        item.how_satisfied || '—',
      ].join('\t'),
    )
  })

  return lines.join('\n')
}

export default buildApplicabilityText
